import { Instance, getRoot, types } from 'mobx-state-tree';
import { RootStoreModel } from '../Root/RootStore';

export const PathModel = types.model('PathModel', {
  _id: types.identifier,
  title: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  shortDescription: types.maybeNull(types.string),
  longDescription: types.maybeNull(types.string),
  humanReadableId: types.maybeNull(types.string),
  published: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  numberSessions: types.maybeNull(types.number),
  totalNumberSessions: types.maybeNull(types.number),
  userPath:types.maybeNull(types.string),
  completelyLoaded:types.boolean,
  wasThePathAlreadyCompleted: types.boolean,
  hasVideo:types.maybeNull(types.string),
  latestTodaySession:types.maybeNull(types.string),
  todaySessions:types.maybeNull(types.array(types.string)),
  video:types.maybeNull(types.string),
  listItems:types.maybeNull(types.string),
  designSystemColor:types.maybeNull(types.string),
  activePathStatus: types.maybeNull(types.string),
  congratsAlreadyShown: types.maybeNull(types.boolean),
})
  .actions(self => {
    return {
      addExtraSession: (session?: string) => {
        if(!session) {return;}
        if(self.todaySessions?.includes(session)){
          return;
        }
        if(self.todaySessions && self.todaySessions.length>0) {
          self.todaySessions.unshift(session);
        } else {
          self.todaySessions = [session];
        }
      },
      setShownCongrats: () => {
        self.congratsAlreadyShown = true;
      }
    };
  })
  .views(self => ({
    get todaySession() : any {
      return getRoot<Instance<typeof RootStoreModel>>(self).session.session.find(s => s._id === self.latestTodaySession);
    },
    get todaySessionsOrdered() : any {
      return getRoot<Instance<typeof RootStoreModel>>(self).session.session
        .filter(s => self.todaySessions && self.todaySessions.includes(s._id))
        .sort((a,b) => a.order - b.order>0 ? 1 : -1);
    },
    get todayExtraSessions(): any {
      return getRoot<Instance<typeof RootStoreModel>>(self).session.session
        .filter(s => s._id !==self.latestTodaySession && self.todaySessions && self.todaySessions.includes(s._id))
        .sort((a,b) => a.order - b.order>0 ? 1 : -1);
    },

    readPercentage() {
      return(
        (self?.totalNumberSessions ) ? Math.round(100 * (self.numberSessions || 0) / self.totalNumberSessions) : 100
      );
    },
    nbLeft() {
      return(
        (self?.totalNumberSessions) ? (self.totalNumberSessions - (self.numberSessions || 0)) : 0);
    },
    isActive(): boolean  {
      return getRoot<Instance<typeof RootStoreModel>>(self).user.activePath === self._id;
    },
    get programExist() {
      return (!self?.activePathStatus || ['ONGOING','FINISHED_TODAY'].includes(self?.activePathStatus as string));
    },
    get programExistAndNotFinished() {
      return (!self?.activePathStatus || ['ONGOING'].includes(self?.activePathStatus as string));
    },
    get programFinishedToday() {
      return self?.activePathStatus && self.activePathStatus === 'FINISHED_TODAY';
    },
    get hasShownCongrats() {
      if(!self?.congratsAlreadyShown) {
        return false;
      }
      return self.congratsAlreadyShown;
    },
    get sessionIndex() {
      const started = self?.status === 'started';
      const pause = self?.status === 'pause';
      const complete = self?.status === 'complete';
      if(complete) {
        return self?.totalNumberSessions;
      } else if(pause || started) {
        return self?.numberSessions;
      } else {
        return 0;
      }
    }
  }));





export type IPathModel = Instance<typeof PathModel>;


